'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.Flex = undefined;

var _Flex = require('./Flex');

Object.defineProperty(exports, 'Flex', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Flex).default;
  }
});

var _Item = require('./Item');

Object.defineProperty(exports, 'Item', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Item).default;
  }
});

var _Flex2 = _interopRequireDefault(_Flex);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Flex: _Flex2.default,
  Item: _Item2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/react-flex/lib/index.js
// module id = 34
// module chunks = 0